/**
 * @file Frontend API client — FormService.
 */

// src/pages/Admin/Form/FormService.ts

import axiosClient from "../api/axiosClient";

/** Exported const — get All Form Sections. */
export const getAllFormSections = async () => {
  const response = await axiosClient.get("/forms/sections");
  return response.data;
};

/** Exported const — create Form Section. */
export const createFormSection = async (data: any) => {
  const response = await axiosClient.post("/forms/sections", data);
  return response.data;
};

/** Exported const — create Form Sub Section. */
export const createFormSubSection = async (data: any) => {
  const response = await axiosClient.post("/forms/subsections", data);
  return response.data;
};

/** Exported const — create Form Field. */
export const createFormField = async (data: any) => {
  const response = await axiosClient.post("/forms/fields", data);
  return response.data;
};

/** Exported const — update Form Field. */
export const updateFormField = async (fieldId: number, data: any) => {
  const response = await axiosClient.put(`/forms/fields/${fieldId}`, data);
  return response.data;
};

/** Exported const — delete Form Field. */
export const deleteFormField = async (fieldId: number) => {
  const response = await axiosClient.delete(`/forms/fields/${fieldId}`);
  return response.data;
};

// 🔹 Fetch all dropdowns (for DROPDOWN field type)
export const getAllDropdowns = async () => {
  const response = await axiosClient.get("/dropdowns");
  return response.data;
};

/** Unit property definitions (for UNIT field type in form builder). Uses same /units API as contributor forms. */
export interface UnitPropertyOption {
  id: number;
  name: string;
  displayName?: string;
}

/** Exported const — get Unit Properties. */
export const getUnitProperties = async (): Promise<UnitPropertyOption[]> => {
  const response = await axiosClient.get("/units");
  const body = response.data as { success?: boolean; data?: unknown } | unknown[];
  const raw = Array.isArray((body as { data?: unknown[] })?.data)
    ? (body as { data: unknown[] }).data
    : Array.isArray(body)
      ? body
      : [];
  if (!Array.isArray(raw)) return [];

  return raw
    .map((p: Record<string, unknown>) => {
      const id = Number(p?.id);
      if (!Number.isFinite(id)) return null;
      const name = String(p?.name ?? p?.label ?? `Property ${id}`);
      const displayName =
        p?.displayName != null ? String(p.displayName) : undefined;
      return { id, name, displayName };
    })
    .filter(Boolean) as UnitPropertyOption[];
};
